module.exports = __webpack_public_path__ + "img/blue_071.445e0f30.png";